import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiV3 } from '@/utils/api';
import type { AnnouncementsResponse } from '../types';

const QUERY_KEY = ['announcements'] as const;

export const useAnnouncements = () => {
  return useQuery<AnnouncementsResponse>({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const { data } = await apiV3.get<AnnouncementsResponse>('/announcements');
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
};

export const useMarkAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (announcementIds: string[]) => {
      await apiV3.post('/announcements/read', { announcement_ids: announcementIds });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};

export const useMarkAllAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await apiV3.post('/announcements/read-all');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
};
